module.exports = __webpack_public_path__ + "static/media/C5aug.70a0a295.wav";